import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../criticalCareAction';
import fetchApi from "./fetchApi";

function fetchCriticalCareAction() {
  return fetchApi('/v1/fc_api/critical_care_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchCriticalCareAction;
